import { Stack } from '@mui/material'
import { RuuviTag } from '../types'
import { PageTitle } from './PageHeader'
import RuuviTagStatusIndicator from './RuuviTagStatusIndicator'
import { formatMacAddress } from '../utils/ruuviTag'

export interface RuuviTagPageTitleProps {
  ruuviTag: RuuviTag
}

export default function RuuviTagPageTitle({ ruuviTag }: RuuviTagPageTitleProps) {
  return (
    <PageTitle>
      <Stack direction="row" alignItems="center" gap={3}>
        <RuuviTagStatusIndicator ruuviTag={ruuviTag} />
        {ruuviTag?.asset?.name ?? formatMacAddress(ruuviTag.id)}
      </Stack>
    </PageTitle>
  )
}
